// Google Analytics 4 initialization
// Only loads in production if VITE_GA_ID is set

const GA_ID = import.meta.env.VITE_GA_ID;
const isProd = import.meta.env.PROD && GA_ID;

if (isProd) {
  // Load gtag.js script
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.defer = true;
  document.head.appendChild(script);

  // Initialize GA4
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: false });

  // Initial page view
  gtag('event', 'page_view', {
    page_title: document.title,
    page_location: location.href,
  });
}

// Export function to track page views (will be used by React Router component)
export function trackPageView(path, title) {
  if (isProd && window.gtag) {
    window.gtag('event', 'page_view', {
      page_title: title || document.title,
      page_location: location.origin + path,
    });
  }
}
